module.exports = __webpack_public_path__ + "img/IMG_2701.50331dd0.jpg";